/**
 * 🎯 CabinetHeader Component
 * 
 * SignalR ilə real-time bildiriş və balans yeniləmələri.
 * 
 * @version 2.0.0
 */

import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { HerracContext } from '../../App';
import { useSignalR } from './../services/SignalRContext';
import { 
  FaBars, 
  FaBell, 
  FaSignOutAlt, 
  FaWallet,
  FaCog,
  FaWifi
} from 'react-icons/fa';
import axios from 'axios';

function CabinetHeader({ onMenuToggle, isMobile }) {
  const navigate = useNavigate();
  const { user, balance, getUserBalance, setUser, unreadNotificationCount, setUnreadNotificationCount } = useContext(HerracContext);
  const { isAuctionConnected, onNotification, onBalanceUpdated } = useSignalR();
  
  const [loading, setLoading] = useState(false);
  const hasFetched = useRef(false);

  // SignalR - Real-time Notifications
  useEffect(() => {
    if (!user) return;

    const unsubNotif = onNotification((notification) => {
      console.log('🔔 CabinetHeader: Yeni bildiriş', notification);
      setUnreadNotificationCount(prev => prev + 1);
    });

    return () => unsubNotif();
  }, [user, onNotification, setUnreadNotificationCount]);

  // SignalR - Real-time Balance
  useEffect(() => {
    if (!user) return;

    const unsubBalance = onBalanceUpdated((data) => {
      if (data.userId === user.userId) {
        console.log('💰 CabinetHeader: Balans yeniləndi', data.balance);
        getUserBalance(user.userId);
      }
    });

    return () => unsubBalance();
  }, [user, getUserBalance, onBalanceUpdated]);

  const handleLogout = async () => {
    if (!window.confirm('Çıxış etmək istədiyinizə əminsiniz?')) return;

    try {
      setLoading(true);
      await axios.post('https://api.herracim.az/api/account/logout', {}, { withCredentials: true });
      setUser(null);
      navigate('/');
      window.location.reload();
    } catch (error) {
      console.error('Çıxış xətası:', error);
      alert('Çıxış zamanı xəta baş verdi');
      setLoading(false);
    }
  };

  const handleNotificationsClick = () => navigate('/kabinetim/bildirislerim');
  const handleSettingsClick = () => navigate('/kabinetim/ayarlar');
  const handleBalanceClick = () => navigate('/kabinetim/balans');

  const formatBalance = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  return (
    <header className="cabinet-header">
      <div className="cabinet-header__left">
        {isMobile && (
          <button className="cabinet-header__menu-btn" onClick={onMenuToggle} aria-label="Menyu">
            <FaBars />
          </button>
        )}
        <div className="cabinet-header__title-group">
          <h1 className="cabinet-header__title">
            Kabinetim
            {isAuctionConnected && <FaWifi className="cabinet-header__connection-icon" title="Real-time aktiv" />}
          </h1>
          <p className="cabinet-header__subtitle">Xoş gəlmisiniz, {user?.fullName}</p>
        </div>
      </div>

      <div className="cabinet-header__right">
        <button className="cabinet-header__balance" onClick={handleBalanceClick} title="Balans artır">
          <FaWallet className="cabinet-header__balance-icon" />
          <div className="cabinet-header__balance-info">
            <span className="cabinet-header__balance-label">Balans</span>
            <span className="cabinet-header__balance-value">{formatBalance(balance)} AZN</span>
          </div>
        </button>

        <div className="cabinet-header__divider" />

        <button className="cabinet-header__icon-btn" onClick={handleNotificationsClick} aria-label="Bildirişlər" title="Bildirişlər">
          <FaBell />
          {unreadNotificationCount > 0 && (
            <span className="cabinet-header__badge">{unreadNotificationCount > 99 ? '99+' : unreadNotificationCount}</span>
          )}
        </button>

        <button className="cabinet-header__icon-btn" onClick={handleSettingsClick} aria-label="Tənzimləmələr" title="Tənzimləmələr">
          <FaCog />
        </button>

        <div className="cabinet-header__divider" />

        <div className="cabinet-header__user">
          <img
            src={user?.profileImageUrl && user.profileImageUrl !== "NULL" ? `https://api.herracim.az${user.profileImageUrl}` : `/images/profile.svg`}
            alt={user?.fullName}
            className="cabinet-header__avatar"
          />
          {!isMobile && <span className="cabinet-header__username">{user?.fullName}</span>}
        </div>

        <button className="cabinet-header__logout-btn" onClick={handleLogout} disabled={loading} aria-label="Çıxış" title="Çıxış et">
          <FaSignOutAlt />
          {!isMobile && <span>Çıxış</span>}
        </button>
      </div>
    </header>
  );
}

export default CabinetHeader;